import { createContext } from 'react'

const defaultAnalyticsContext = {
  analytics: undefined,
}

export const AnalyticsContext = createContext(defaultAnalyticsContext)
